export default __webpack_public_path__ + "static/audio-cardio-4-bb-c1226ec295052c5456c365de51fb04ce.webp";